var map = {
	"./blog.yml": 111,
	"./cloud.yml": 112,
	"./color.yml": 113,
	"./country.yml": 114,
	"./dio.yml": 115,
	"./doc.yml": 116,
	"./emoji.yml": 117,
	"./git.yml": 118,
	"./icon.yml": 119,
	"./license.yml": 120,
	"./link.yml": 121,
	"./metrics.yml": 122,
	"./people.yml": 123,
	"./soft.yml": 124,
	"./src.yml": 125,
	"./status.yml": 126
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 110;